<template>
    <div>
        <!--  排行切换  -->
        <div class="rank-switch-wrap" v-if="!selectItemShow('order')">
            <!--      排行元素      -->
            <template v-for="item in rankRenderList">
                <div class="rank-item" @click.stop="changeActiveRank(item)"
                     :class="{'active-rank-item': activeRankKey === item.key,[item.keys]:true}">
                    <img v-if="activeRankKey === item.key" class="rank-icon" :src="item.activeIcon" alt="">
                    <img v-else class="rank-icon" :src="item.icon" alt="">
                    <div class="rank-item-title">
                        <span>{{ item.title }}</span>
                        <span>排名</span>
                    </div>
                </div>
            </template>
        </div>

        <!--  排行数据  -->
        <div class="rank-data-wrap">
            <!--  排行标题  -->
            <div class="rank-data-title">
                <span>参与</span>
                <span>{{ activeRankObj.title }}</span>
                <span>{{ rankResultTotal }}</span>
                <span>{{ activeRankObj.util }}</span>
            </div>
            <!--     排行筛选点击       -->
            <div class="rank-selected">
                <!--        筛选项        -->
                <template v-for="item in selectList">
                    <div v-if="item.type != 'time'" @click="selectShow(item)" class="rank-select-item"
                         :class="{'rank-select-item-active':item.active}" :key="item.type">
                        <span> {{ item.title }}</span>
                        <img v-if="item.active" src="@/assets/images/user-share/select_d.png" alt="">
                        <img v-else src="@/assets/images/user-share/select_u.png" alt="">
                    </div>
                </template>
                <!--        排序容器        -->
                <transition name="fade">
                    <div v-if="selectItemShow('order')" class="order-content">
                        <div class="arrow"></div>
                        <div class="entity">
                            <div @click.stop="selectOrder(item)" class="entity-item" v-for="item in orderRenderList"
                                 :key="item.title">
                                <img :src="item.icon" alt="">
                                <span>{{ item.title }}</span>
                            </div>
                        </div>
                    </div>
                </transition>
                <!--         数据筛选容器       -->
                <transition name="fade">
                    <div v-if="selectItemShow('date')" class="date-content">
                        <div class="entity">

                            <div>
                                <div class="entity-title">阅读量</div>
                                <div class="entity-date">
                                    <div class="btn-item" :class="{'btn-item-active':per.select}"
                                         v-for="per in dateReadNum" @click.stop="selectReadNum(per)" :key="per.key">
                                        <img class="select-icon" src="@/assets/images/user-share/select-poit.png"
                                             alt="">
                                        <span>{{ per.title }}</span>
                                    </div>
                                    <div class="btn-item hidden"></div>
                                </div>
                            </div>
                            <!-- 大区选择 -->
                            <div>
                                <div class="entity-title">各大区（可多选）</div>
                                <div class="entity-date">
                                    <div @click.stop="selectAreaInfo(area)" class="btn-item"
                                         :class="{'btn-item-active':area.select}" v-for="area in rankSelectAreaResult"
                                         :key="area.region_value">
                                        <img class="select-icon" src="@/assets/images/user-share/select-poit.png"
                                             alt="">
                                        <span>{{ area.region_name }}</span>
                                    </div>
                                </div>
                            </div>
                            <!-- 省市选择 -->
                            <div v-if="activeRankKey == 'province' || activeRankKey == 'city'">
                                <div class="entity-title" @click="showPick">
                                    <span>省市选择</span>
                                    <img src="@/assets/images/user-share/to-right.png" alt=""/>
                                </div>
                                <div class="entity-date">
                                    <div class="btn-item" v-if="objList.province">
                                        {{ objList.province }} - {{ objList.city }}
                                    </div>
                                </div>
                            </div>
                            <!-- 办事处选择 -->
                            <!-- <div>
                                <div @click.stop="$router.push({name:'officeSelect'})" class="entity-title">
                                    <span>选择办事处（可多选）</span>
                                    <img src="../../../assets/images/user-share/to-right.png" alt=""/>
                                </div>
                                <div class="entity-date office-entity-date">
                                    <div class="office-item" v-for="item in selectJobResult" :key="item.id">
                                        <div class="text"> {{ item.name }}</div>
                                        <div @click.stop="handleRemoveOffice(item)" class="remove-office">x</div>
                                    </div>
                                </div>
                            </div> -->
                            <!-- 人员选择 -->
                            <!--                            <div>-->
                            <!--                                <div class="entity-title">人员属性</div>-->
                            <!--                                <div class="entity-date">-->
                            <!--                                    <div class="btn-item" :class="{'btn-item-active':per.select}" v-for="per in datePersonType" @click.stop="selectPerson(per)" :key="per.key">-->
                            <!--                                        <img class="select-icon" src="@/assets/images/user-share/select-poit.png" alt="">-->
                            <!--                                        <span>{{ per.title }}</span>-->
                            <!--                                    </div>-->
                            <!--                                    <div class="btn-item hidden"></div>-->
                            <!--                                </div>-->
                            <!--                            </div>-->

                        </div>
                        <!--           确定按钮             -->
                        <div class="confirm-button">
                            <div class="btn" @click.stop="confirmCancelDateSelect(true)">取消</div>
                            <div class="btn result" @click="resetSelect()">重置</div>
                            <div class="btn confirm" @click.stop="confirmCancelDateSelect(false)">确定</div>
                        </div>
                    </div>
                </transition>
                <!--        时间选择容器        -->
                <Overlay @click.self="overlayClickHidden" :show="selectItemShow('time')" class="time-content">
                    <!--            时间确认            -->
                    <div class="time-content-confirm">
                        <div class="time-button">
                            <div class="time-btn-item" :class="{'time-btn-item-active':btn.select}"
                                 @click.stop="setSelectTime(btn)" v-for="btn in dateTimeScope" :key="btn.key">{{
                                    btn.title
                                }}
                            </div>
                        </div>
                        <div v-show="showCustomSelect">
                            <div class="custom-title">自定义</div>
                            <div class="time-scope">
                                <div @click.stop="selectTimeCustomView(0)" class="time-item">{{
                                        selectTimeCustom(0)
                                    }}
                                </div>
                                <span>至</span>
                                <div @click.stop="selectTimeCustomView(1)" class="time-item">{{
                                        selectTimeCustom(1)
                                    }}
                                </div>
                            </div>
                        </div>
                        <div class="button-view">
                            <div class="btn" @click.stop="timeSelectRest">重置</div>
                            <div class="btn confirm" @click.stop="timeSelectConfirm">确认</div>
                        </div>
                    </div>
                    <!--            时间选择            -->
                    <div v-if="dateTimeSelectIndex !== null" class="time-content-select">
                        <DatetimePicker v-model="dateTimeCurrentDate" @cancel="dateTimeSelectIndex = null"
                                        @confirm="selectTimeCustomSet($event,dateTimeSelectIndex)"
                                        :max-date="dataTimeMaxDate" type="date" :formatter="timeFormatter"/>
                    </div>
                </Overlay>

            </div>
            <!--    数据展示        -->
            <table class="rank-data-table">
                <tr class="rank-tr-head">
                    <th class="sort"></th>
                    <th v-for="th in tableColumn" :key="th.title">{{ th.title }}</th>
                </tr>
                <tr class="rank-tr-body" v-for="(item,index) in rankCommentView" :key="item.id">
                    <td class="sort">
                        <div :class="{'top-rank-td-item':index < 3}">
                            {{ index + 1 }}
                        </div>
                    </td>
                    <!--       name 项目名或者其他名字，  project 项目类型            -->
                    <td v-for="tableKey in tableColumnIndex" @click="activeRankKey === 'project' && navToProject(item)"
                        :class="{'align-left-td':tableKey === 'name' && activeRankKey === 'project'}" :key="tableKey">
                        {{ item[tableKey] }}
                    </td>
                </tr>
            </table>
            <!--     查看更多       -->
            <div class="look-more" @click.stop="loadMoreDate">
                查看更多
            </div>
        </div>
        <awesome-picker v-if="bPicker" ref="picker" :anchor="anchor" :data="addressObj" :colorConfirm="sColor"
                        :colorCancel="sColor" @cancel="handlePickerCancel"
                        @confirm="handlePickerConfirm"></awesome-picker>
    </div>
</template>
<script>
import {DatetimePicker, Overlay} from "vant";
import day from "dayjs";
import {mapState} from "vuex";

export default {
    components: {
        Overlay,
        DatetimePicker,
    },
    data() {
        return {
            bPicker: false,
            arrSelect: [],
            addressData: [],
            objList: {
                province: '',
                province_id: '',
                city_id: '',
                city: '',
            },
            addressObj: [],
            anchor: [
                {
                    index: 0,
                    value: "全国",
                },
                {
                    index: 0,
                    value: "全国",
                },
            ], //默认选中
            sColor: "#2395ff", //picker取消确定按钮颜色
            // 当天日期
            nowDate: day().format("YYYY年MM月DD日"),
            // 排名渲染数组
            rankRenderList: [
                {
                    key: "region",
                    title: "大区",
                    view: true,
                    share: true,
                    icon: require("@/assets/images/user-share/region.png"),
                    activeIcon: require("@/assets/images/user-share/region_a.png"),
                    util: "个",
                },
                {
                    key: 'province',
                    title: '省级',
                    view: true,
                    share: true,
                    icon: require('@/assets/images/user-share/city.png'),
                    activeIcon: require('@/assets/images/user-share/city_a.png'),
                    util: '座',
                },
                {
                    key: 'city',
                    title: '市级',
                    share: true,
                    view: true,
                    icon: require('@/assets/images/user-share/city.png'),
                    activeIcon: require('@/assets/images/user-share/city_a.png'),
                    util: '座',
                },
                // {
                //     key: 'office',
                //     title: '办事处',
                //     icon: require('../../../assets/images/user-share/office.png'),
                //     activeIcon: require('../../../assets/images/user-share/office_a.png'),
                //     util: '个',
                // },
                // {
                //     key: "sellers",
                //     title: "直销员",
                //     share:true,
                //     view:false,
                //     icon: require("@/assets/images/user-share/sellers.png"),
                //     activeIcon: require("@/assets/images/user-share/sellers_a.png"),
                //     util: "个",
                // },
                {
                    key: "project",
                    title: "项目",
                    view: true,
                    share: true,
                    icon: require("@/assets/images/user-share/project.png"),
                    activeIcon: require("@/assets/images/user-share/project_a.png"),
                    util: "个",
                },
            ],
            // 筛选数组
            selectList: [
                {
                    title: day().format("YYYY.MM"),
                    type: "time",
                    active: false,
                },
                {
                    title: "数据筛选",
                    type: "date",
                    active: false,
                },
                {
                    title: "排序",
                    type: "order",
                    active: false,
                },
            ],
            // 表格栏
            tableColumn: [
                {
                    key: "name",
                    title: "大区排名",
                },
                {
                    key: "total",
                    title: "总阅读量",
                },
            ],
            // 时间选择范围
            dateTimeScope: [
                {
                    title: "自定义",
                    value: [
                        day().subtract(1, "day").format("YYYY-MM-DD"),
                        day().format("YYYY-MM-DD"),
                    ],
                    key: "custom",
                    select: true,
                },
                {
                    title: "近7天",
                    value: [
                        day().subtract(7, "day").format("YYYY-MM-DD"),
                        day().format("YYYY-MM-DD"),
                    ],
                    key: "week",
                    select: false,
                },
                {
                    title: "近30天",
                    value: [
                        day().subtract(30, "day").format("YYYY-MM-DD"),
                        day().format("YYYY-MM-DD"),
                    ],
                    key: "month",
                    select: false,
                },
            ],
            // 时间选择器当前选择索引
            dateTimeSelectIndex: null,
            // 时间选择器默认时间
            dateTimeCurrentDate: new Date(),
            // 时间选择器的最大时间
            dataTimeMaxDate: new Date(),
            // 时间选择器最小时间
            dateTimeMinDate: new Date(2021, 9, 26),
            // 排序渲染数组
            orderRenderList: [
                {
                    title: "顺序",
                    icon: require("@/assets/images/user-share/paixu_up.png"),
                    value: {
                        total_desc: 1,
                        total_asc: 0,
                    },
                },
                {
                    title: "倒序",
                    icon: require("@/assets/images/user-share/paixu_down.png"),
                    value: {
                        total_desc: 0,
                        total_asc: 1,
                    },
                },
            ],
        }
    },
    computed: {

        // 激活的排行对象
        activeRankObj() {
            return this.rankRenderList.find(
                (i) => i.key === this.activeRankKey
            );
        },
        // 表格栏索引
        tableColumnIndex() {
            return this.tableColumn.map((i) => i.key);
        },
        // 选中的办事处
        selectJobResult() {
            return this.$store.getters["userShareDataView/selectJobResult"];
        },
        // 控制自定义时间选择显示
        showCustomSelect() {
            return this.dateTimeScope.find((i) => i.key === "custom")?.select;
        },
        ...mapState({
            // 列表总数
            rankResultTotal: (state) => state.userShareDataView.rankResultTotal,
            // 页面表格排行数据
            rankCommentView: (state) => state.userShareDataView.rankCommentView,
            // 激活的排行类型
            activeRankKey: (state) => state.userShareDataView.activeRankKey,
            // 阅读筛选
            dateReadNum: (state) => state.userShareDataView.dateReadNum,
            // 人员筛选属性
            datePersonType: (state) => state.userShareDataView.datePersonType,
            // 数据筛选大区数据
            rankSelectAreaResult: (state) =>
                state.userShareDataView.rankSelectAreaResult,
            // 用户tp5id
            tp5XcxUserid: (state) => state.userShareDataView.tp5XcxUserid,
        }),
    },
    created() {
        // this.fetchPageData();
        // this.arrgoAddress();
    },
    methods: {
        update(start, end) {
            // 保存选择的时间
            this.$store.commit({
                type: "userShareDataView/CHANGE_RANK_SELECT_TIME",
                time: {start: start, end: end},
            });
            this.$nextTick(() => {
                this.fetchPageData();
                if (!this.addressData) {
                    this.arrgoAddress();
                }
            })
        },
        changeTab(index) {
            this.nShowTab = index
        },
        //二级联动
        showPick() {
            this.bPicker = true;
            setTimeout(() => {
                this.$refs.picker.show();
            }, 200)
        },
        handlePickerConfirm(e) {
            console.log(e, '----->')
            let that = this;
            that.arrSelect = e;
            let addressData = that.addressData;
            let objprovinces = addressData[0].find((item) => {
                return item.name.indexOf(e[0].value.slice(0, 2)) > -1;
            });
            if (objprovinces) {
                let objCity = addressData[objprovinces.id].find((item) => {
                    return item.name.indexOf(e[1].value.slice(0, 2)) > -1;
                });
                let provinceId = objprovinces.id;
                let cityId = objCity.id;
                let province = objprovinces.name;
                let city = objCity.name;
                let obj = {};
                obj.city_id = cityId;
                obj.province_id = provinceId;
                obj.province = province;
                obj.city = city;
                that.objList = obj;
                this.$store.commit({
                    type: "userShareDataView/CHANGE_PROVINCE",
                    obj,
                });
            }
        },
        handlePickerCancel() {
            this.anchor = this.arrSelect
        },
        arrgoAddress() {
            this.$http
                .get(
                    "https://pro-core.babycdn.com/2021/aosmith/lottery/china.json"
                )
                .then((res) => {
                    let objAddress = res.body.data.result;
                    this.addressData = objAddress;
                    let dataobj = objAddress[0];
                    var addressObj = [];
                    for (let p = 0; p < dataobj.length; p++) {
                        var children = [];
                        let cityId = dataobj[p].id;
                        for (let c = 0; c < objAddress[cityId].length; c++) {
                            let countyId = objAddress[cityId][c].id;
                            if (objAddress[countyId]) {
                                var areaList = [];
                                var areaIdList = [];
                                for (
                                    let k = 0;
                                    k < objAddress[countyId].length;
                                    k++
                                ) {
                                    areaList.push(objAddress[countyId][k]);
                                    areaIdList.push(objAddress[countyId][k].id);
                                }
                            }
                            let cityObj = {
                                value: objAddress[cityId][c].name,
                                id: objAddress[cityId][c].id,
                            };
                            children.push(cityObj);
                        }
                        let obj = {
                            value: dataobj[p].name,
                            id: dataobj[p].id,
                            children: children,
                        };
                        addressObj.push(obj);
                    }
                    this.addressObj = addressObj;
                    console.log(addressObj, '地址');
                });
        },
        /**
         * 获取分享标识
         * @return {{value: string, key: string}}
         */
        getShareLabel() {
            const url = new URL(location.href);
            // 约定的出口类型 search_key;
            const key = this.$store.state.shareOutKey;
            return {key, value: url.searchParams.get(key)};
        },
        /**
         * 调整项目详情
         * @param item
         */
        navToProject(item) {
            // console.log(item);
            debugger;
            const id = item.project_id;
            const dataSet = encodeURIComponent(
                JSON.stringify({
                    ut_source: "praise_map",
                    type: "",
                    city: "",
                    community_name: "",
                    img_url: "",
                })
            );
            const that = this;
            const ua = window.navigator.userAgent.toLowerCase();
            const label = this.getShareLabel();

            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                if (ua.match(/WxWork/i) == "wxwork") {
                    if (wx?.miniProgram?.getEnv) {
                        wx.miniProgram.getEnv(function (res) {
                            if (res.miniprogram) {
                                // 小程序环境下逻辑
                                // alert("小程序环境下逻辑");
                                wx.miniProgram.redirectTo({
                                    url: `/pages/antdetails/index?id=${id}&parame=${dataSet}`,
                                });
                            } else {
                                //非小程序环境下逻辑
                                // alert("非小程序环境下逻辑");
                                that.$router.push({
                                    path: "/antdetails/index",
                                    query: {
                                        id,
                                        [label.key]: [label.value],
                                        ut_source: "praise_map",
                                    },
                                });
                            }
                        });
                    } else {
                        //企业微信环境下
                        that.$router.push({
                            path: "/antdetails/index",
                            query: {
                                id,
                                [label.key]: [label.value],
                                ut_source: "praise_map",
                            },
                        });
                    }
                } else {
                    //判断是否是微信环境
                    //微信环境
                    wx.miniProgram.getEnv(function (res) {
                        if (res.miniprogram) {
                            // 小程序环境下逻辑
                            // alert("小程序环境下逻辑");
                            wx.miniProgram.redirectTo({
                                url: `/pages/antdetails/index?id=${id}&parame=${dataSet}`,
                            });
                        } else {
                            //非小程序环境下逻辑
                            // alert("非小程序环境下逻辑");
                            that.$router.push({
                                path: "/antdetails/index",
                                query: {
                                    id,
                                    ut_source: "praise_map",
                                    [label.key]: [label.value],
                                },
                            });
                        }
                    });
                }
            } else {
                // 非微信环境逻辑
                // alert("非微信环境逻辑");
                that.$router.push({
                    path: "/antdetails/index",
                    query: {id, ut_source: "praise_map"},
                });
            }
        },
        /**
         * 重置选择条件
         */
        resetSelect() {
            // this.selectShow(this.selectList.find(i => i.type === 'date'));
            // 办事处清空
            this.$store.commit({
                type: "userShareDataView/CHANGE_SELECT_OFFICE",
                all: true,
            });
            // 大区清空
            this.$store.commit({type: "userShareDataView/CHANGE_AREA_SELECT"});
            // 人员清空
            this.$store.commit({type: "userShareDataView/CHANGE_PERSON_SELECT"});
        },
        /**
         * 初始化页面数据
         * @return {Promise<void>}
         */
        fetchPageData() {
            // 获取排行数据
            this.$store.dispatch({
                type: "userShareDataView/fetchViewRankC",
            });
            if (!this.rankSelectAreaResult) {
                // 获取筛选配置数据
                this.$store.dispatch({
                    type: "userShareDataView/fetchEnterpriseFilterAction",
                });
            }
        },
        /**
         * 切换排行类型
         * @param  item 需要切换的排行项
         */
        changeActiveRank(item) {
            const {key, title} = item;
            if (this.activeRankKey === key) return;
            // 改变激活的KEY
            this.$store.commit({
                type: "userShareDataView/CHANGE_ACTIVE_RANK",
                key,
            });
            // 给列表填充动态栏
            this.tableColumn.shift();
            this.tableColumn.unshift({
                key: "name",
                title: `${title}排名`,
            });
            // 拉取新的数据
            this.$store.dispatch({
                type: "userShareDataView/fetchViewRankC",
            });
            // 评论阅读
            this.$store.dispatch({
                type: "userShareData/fetchViewTotalActionC",
                source: this.$store.state.userShareDataView.dateType2.join(',')
            });
            // this.resetSelect();
        },
        /**
         * 筛选控制
         * @param selectItem
         */
        selectShow(selectItem) {
            const {type, active} = selectItem;
            // 改变激活状态
            this.selectList = this.selectList.map((i) => {
                if (i.type === type) {
                    i.active = !active;
                } else {
                    i.active = false;
                }
                return i;
            });
        },
        /**
         * 获取筛选子项显示
         * @param {string} type 筛选类型
         * @return {boolean|*}
         */
        selectItemShow(type) {
            return this.selectList.find((i) => i.type === type).active;
        },
        /**
         * 时间选择器格式整理
         * @param type
         * @param val
         * @return {string|*}
         */
        timeFormatter(type, val) {
            if (type === "year") {
                return val + "年";
            }
            if (type === "month") {
                return val + "月";
            }
            if (type === "day") {
                return val + "日";
            }
            return val;
        },
        /**
         * 自定义时间选择
         * @param index
         */
        selectTimeCustom(index) {
            // custom 自定义时间类型
            return this.dateTimeScope.find((i) => i.key === "custom").value[
                index
                ];
        },
        /**
         * 自定义时间设置
         * @param index
         * @param val 被设置的值
         */
        selectTimeCustomSet(val, index) {
            this.dateTimeScope = this.dateTimeScope.map((i) => {
                // custom 自定义时间类型
                if (i.key === "custom")
                    i.value[index] = day(val).format("YYYY-MM-DD");
                return i;
            });
            this.dateTimeSelectIndex = null;
        },
        /**
         * 设置当前时间选择索引
         * @param index
         */
        selectTimeCustomView(index) {
            this.dateTimeSelectIndex = index;
        },
        /**
         * 时间选择遮罩点击
         */
        overlayClickHidden() {
            this.selectShow({type: "time", active: true});
        },
        /**
         * 时间按钮选择
         * @param item
         */
        setSelectTime(item) {
            const {key, select} = item;
            this.dateTimeScope = this.dateTimeScope.map((i) => {
                i.select = false;
                if (i.key === key) i.select = !select;
                return i;
            });
        },
        /**
         * 时间选择重置
         */
        timeSelectRest() {
            const defaultCustomTime = [
                day().subtract(1, "day").format("YYYY-MM-DD"),
                day().format("YYYY-MM-DD"),
            ];
            this.dateTimeScope = this.dateTimeScope.map((i) => {
                i.select = false;
                // 自定义时间重置
                if (i.key === "custom") i.value = defaultCustomTime;
                return i;
            });
            // 清空保存选择的时间
            this.$store.commit({
                type: "userShareDataView/CHANGE_RANK_SELECT_TIME",
            });
            // 拉取新数据
            this.$store.dispatch({
                type: "userShareDataView/fetchViewRankC",
            });

            // 关闭选择弹窗
            this.overlayClickHidden();
        },
        /**
         * 时间筛选确认按钮
         */
        timeSelectConfirm() {
            // 判断是否选择了
            const isSelect = this.dateTimeScope.find((i) => i.select);
            if (!isSelect) {
                this.$toast("请选择时间");
            } else {
                // 保存选择的时间
                this.$store.commit({
                    type: "userShareDataView/CHANGE_RANK_SELECT_TIME",
                    time: {start: isSelect.value[0], end: isSelect.value[1]},
                });
                // 拉取新数据
                this.$store.dispatch({
                    type: "userShareDataView/fetchViewRankC",
                });
                this.changeSelectTimeShowView(
                    `${isSelect.value[0]}——${isSelect.value[1]}`
                );

                // 关闭选择弹窗
                this.overlayClickHidden();
            }
        },
        /* 父组件调用*/
        timeSelectConfirmParent(start, end) {
            // 保存选择的时间
            this.$store.commit({
                type: "userShareDataView/CHANGE_RANK_SELECT_TIME",
                time: {start: start, end: end},
            });
            // 拉取新数据
            this.$store.dispatch({
                type: "userShareDataView/fetchViewRankC",
            });
        },
        /**
         * 改变选择时间视图显示
         */
        changeSelectTimeShowView(title) {
            this.selectList = this.selectList.map((i) => {
                if (i.type === "time") {
                    i.title = title;
                }
                return i;
            });
        },
        /**
         * 选择排序
         * @param item
         */
        selectOrder(item) {
            // 保存排序条件
            this.$store.commit({
                type: "userShareDataView/CHANGE_RANK_SELECT_ORDER",
                order: item ? JSON.stringify(item.value) : undefined,
            });
            // 拉取新数据
            this.$store.dispatch({
                type: "userShareDataView/fetchViewRankC",
            });
            // 隐藏
            this.selectShow(this.selectList.find((i) => i.type === "order"));
        },
        /**
         * 选择大区
         * @param area
         */
        selectAreaInfo(area) {
            this.$store.commit({
                type: "userShareDataView/CHANGE_AREA_SELECT",
                area,
            });
        },
        /**
         * 选择人员
         * @param person
         */
        selectPerson(person) {
            this.$store.commit({
                type: "userShareDataView/CHANGE_PERSON_SELECT",
                person,
            });
        },
        /**
         * 选择阅读量
         * @param person
         */
        selectReadNum(person) {
            this.$store.commit({
                type: "userShareDataView/CHANGE_READ_NUM2",
                person,
            });
            console.log(this.$store.state.userShareDataView.dateType2.join(','), 'this.$store.state.userShareDataView.dateType2.join(\',\')')
            // 评论阅读
            this.$store.dispatch({
                type: "userShareData/fetchViewTotalActionC",
                source: this.$store.state.userShareDataView.dateType2.join(',')
            });
        },
        /**
         * 数据筛选确认取消按钮
         */
        async confirmCancelDateSelect(cancel) {
            // 把条件保存
            this.$store.commit({
                type: "userShareDataView/CHANGE_RANK_SELECT_DATE",
                cancel,
            });
            // 拉取新数据
            await this.$store.dispatch({
                type: "userShareDataView/fetchViewRankC",
            });
            // 关闭面板
            this.selectShow(this.selectList.find((i) => i.type === "date"));

            // 如果是取消，把数据初始化
            if (cancel) {
                // 办事处清空
                this.$store.commit({
                    type: "userShareDataView/CHANGE_SELECT_OFFICE",
                    all: true,
                });
                // 大区清空
                this.$store.commit({
                    type: "userShareDataView/CHANGE_AREA_SELECT",
                });
                // 人员清空
                this.$store.commit({
                    type: "userShareDataView/CHANGE_PERSON_SELECT",
                });
            }
        },
        /**
         * 加载更多数据
         */
        loadMoreDate() {
            this.$toast("没有更多数据了")

            // 2023.2.15 取消了分页功能
            // const loadEnd = this.$store.getters["userShareDataView/loadMoreEnd"];
            //
            // loadEnd
            //     ? this.$toast("没有更多数据了")
            //     : this.$store.dispatch({
            //         type: "userShareDataView/fetchViewRankC",
            //         push: true,
            //     });
        },
        /**
         * 移除选择的办事处
         * @param item
         */
        handleRemoveOffice(item) {
            this.$store.commit({
                type: "userShareDataView/CHANGE_SELECT_OFFICE",
                office: item,
            });
        },
    },
}
</script>
<style scoped lang="scss">
@import "../../report";
</style>
